import OrdersRepository from 'client-sdk/src/Repository/orders-repository';
import {takeLatest, put} from 'redux-saga/effects';
import {
  GET_ORDERS,
  GET_ORDERS_FAILED,
  GET_ORDERS_SUCCESS,
  CHANGE_ORDER_STATUS,
  CHANGE_ORDER_STATUS_FAILED,
  CHANGE_ORDER_STATUS_SUCCESS,
} from './constants';
import handleError from '../../utils/handleError';
import handleNotfication from '../../utils/handleNotfication';
import {flattenObject} from '../../utils/helpers';
const token = localStorage.getItem('token') || '';

export function* getOrders(actions: any) {
  try{
    const {response,count} = yield OrdersRepository.getOrders(actions);
  yield put({
    type: GET_ORDERS_SUCCESS,
    data: response.data,
    count: count.data,
  });
} catch (error) {
  yield put({
    type: GET_ORDERS_FAILED,
    error: error.message,
  });
  handleError(error.response);
}
}
export function* changeOrderStatus(actions: any) {
  try{
    const {pagination, callback} = yield OrdersRepository.updateOrderStatus(actions);
    yield put({
      type: CHANGE_ORDER_STATUS_SUCCESS,
    });
    callback && callback();
} catch (error) {
  yield put({
    type: CHANGE_ORDER_STATUS_FAILED,
    error: error.message,
  });
  handleError(error.response);
}
}
export default function* driverSaga() {
    yield takeLatest(GET_ORDERS, getOrders);
    yield takeLatest(CHANGE_ORDER_STATUS, changeOrderStatus);
}
